import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
@Component({
  selector: "app-delete-popup",
  templateUrl: "./delete-popup.component.html",
  styleUrls: ["./delete-popup.component.scss"],
})
export class DeletePopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DeletePopupComponent>
  ) {}
  text = this.data;
  ngOnInit(): void {}
  close() {
    this.dialogRef.close("false");
  }
  submit() {
    this.dialogRef.close("true");
  }
}
